import {useEffect, useLayoutEffect} from 'react'
import {IS_BROWSER} from 'tizra'

export const useIsomorphicLayoutEffect = IS_BROWSER
  ? useLayoutEffect
  : useEffect
